import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  DEFAULT_SELECTION_FILTERS,
  FilterStateSelection,
  UpdateSelectionFilterPayload,
} from "./types";

const initialState: FilterStateSelection = {
  filters: DEFAULT_SELECTION_FILTERS,
};

const selectionFilterSlice = createSlice({
  name: "selecaoFilter",
  initialState,
  reducers: {
    updateFilter(
      state,
      action: PayloadAction<UpdateSelectionFilterPayload>,
    ): void {
      const { key, value } = action.payload;
      state.filters = { ...state.filters, [key]: value };
    },
    resetFilters() {
      return initialState;
    },
  },
});

export const { updateFilter, resetFilters } = selectionFilterSlice.actions;
export default selectionFilterSlice.reducer;
